export default __webpack_public_path__ + "static/media/quantity.428fc692.svg";